import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    Typography,
    TextField,
    Button,
    Box,
    IconButton,
    Select,
    MenuItem,
    FormControl
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import returnModalStyles from './style';
const ReturnPurchaseOrderModal = ({ open, onClose, onConfirm }) => {
    const [orderNumber, setOrderNumber] = useState('5');
    const [selectedReason, setSelectedReason] = useState('');
    const [otherReason, setOtherReason] = useState('');

    const reasonOptions = [
        'Select',
        'Defective items',
        'Wrong items delivered',
        'Quality issues',
        'Damaged during shipping',
        'Not as described',
        'Other'
    ];

    const handleConfirm = () => {
        onConfirm({
            orderNumber,
            reason: selectedReason === 'Other' ? otherReason : selectedReason,
            otherReason
        });
        onClose();
    };

    const handleCancel = () => {
        setSelectedReason('');
        setOtherReason('');
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={returnModalStyles.dialog}
        >
            <DialogContent sx={returnModalStyles.content}>
                <Box sx={returnModalStyles.header}>
                    <Typography sx={returnModalStyles.title}>
                        Return Purchase Order
                    </Typography>
                    <IconButton onClick={onClose} sx={returnModalStyles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={returnModalStyles.body}>
                    <Box sx={returnModalStyles.field}>
                        <Typography sx={returnModalStyles.label}>
                            Order Number
                        </Typography>
                        <TextField
                            value={orderNumber}
                            onChange={(e) => setOrderNumber(e.target.value)}
                            variant="outlined"
                            fullWidth
                            sx={returnModalStyles.input}
                        />
                    </Box>

                    <Box sx={returnModalStyles.field}>
                        <Typography sx={returnModalStyles.label}>
                            Select a Reason
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                value={selectedReason}
                                placeholder='Select a Reason'
                                onChange={(e) => setSelectedReason(e.target.value)}
                                sx={returnModalStyles.select}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                    Select a Reason
                                </MenuItem>
                                {reasonOptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={returnModalStyles.field}>
                        <Typography sx={returnModalStyles.label}>
                            Other Reason
                        </Typography>
                        <TextField
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={1}
                            sx={returnModalStyles.textarea}
                        />
                    </Box>
                </Box>

                <Box sx={returnModalStyles.actions}>
                    <Button
                        onClick={handleCancel}
                        sx={{ ...returnModalStyles.button, ...returnModalStyles.cancelButton }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        sx={{ ...returnModalStyles.button, ...returnModalStyles.confirmButton }}
                    >
                        Confirm
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ReturnPurchaseOrderModal;